/* eslint-disable import/no-extraneous-dependencies */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */

import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
import Tab from '@mui/material/Tab';
import { TabContext } from '@mui/lab';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PaymentAuthorizeNet from './authorize-net';
import PaymentStipe from './stipe';
import PaymentPaypal from './paypal';
import PaymentVeem from './veem';
// import PaymentBankOfAmerica from './bankof-america';
import PaymentClover from './clover';

export default function PaymentSettings() {
  const [tabValue, setTabValue] = useState('1');

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        {/* <Stack direction="row" spacing={1} alignItems="center"> */}
        <Typography className="" component="h2" variant="h2">
          Payment Settings
        </Typography>
        {/* </Stack> */}
      </div>
      <Box className="tabWrapper" sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              className=""
              textColor="secondary"
              indicatorColor="secondary"
              onChange={handleTabChange}
              aria-label="lab API tabs example"
            >
              <Tab label="Authorize.net" value="1" />
              <Tab label="Stripe" value="2" />
              <Tab label="Paypal" value="3" />
              <Tab label="Veem" value="4" />
              {/* <Tab label="Bank of America" value="5" /> */}
              <Tab label="Clover" value="6" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <PaymentAuthorizeNet />
          </TabPanel>
          <TabPanel value="2">
            <PaymentStipe />
          </TabPanel>
          <TabPanel value="3">
            <PaymentPaypal />
          </TabPanel>
          <TabPanel value="4">
            <PaymentVeem />
          </TabPanel>
          {/* <TabPanel value="5">
            <PaymentBankOfAmerica />
          </TabPanel> */}
          <TabPanel value="6">
            <PaymentClover />
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
}
